<template>
  <v-navigation-drawer
    app
    permanent
  >
    <v-container class="side-nav pa-0">
      <v-list
        class="pt-0"
        active-strategy="leaf"
        open-strategy="multiple"
        :opened="openedGroups"
      >
        <v-list-item
          prepend-icon="custom:home"
          title="ホーム"
          link
          slim
          class="list-home"
          :to="{ name: 'main'}"
          :class="route.path == '/' ? 'home-active' : ''"
        >
        </v-list-item>

        <v-list-item
          prepend-icon="custom:chart"
          title="登録・利用数推移"
          :to="{ path: '/yearly_summary' }"
          link
          slim
        >
        </v-list-item>

        <v-list-group
          value="achievements"
          collapse-icon="none"
        >
          <template v-slot:activator="{ props }">
            <v-list-item
              prepend-icon="custom:board"
              title="オンライン相談"
              class="no-click"
              slim
            ></v-list-item>
          </template>

          <v-list-item
            title="主訴一覧"
            prepend-icon="mdi-chevron-right"
            link
            slim
            :to="{ path: role.isSales() ? '/complaints_edit' : '/complaints'}"
          ></v-list-item>
          <v-list-item
            title="アンケートフリー回答一覧"
            prepend-icon="mdi-chevron-right"
            :to="{ path: role.isSales() ? '/questionnaires_edit' : '/questionnaires'}"
            link
            slim
          >
          </v-list-item>
          <v-list-item
            title="アンケート集計"
            prepend-icon="mdi-chevron-right"
            :to="{ path: '/questionnaires_analytics'}"
            link
            slim
          >
          </v-list-item>
        </v-list-group>

        <v-list-group
          v-if="corporation && corporation.casesearchAvailable"
          value="casesearch"
          collapse-icon="none"
        >
          <template v-slot:activator="{ props }">
            <v-list-item
              prepend-icon="custom:search"
              title="みんなの相談検索"
              class="no-click"
              slim
            ></v-list-item>
          </template>

          <v-list-item
            :to="{ path: '/casesearch_query_logs'}"
            title="検索ワードランキング"
            prepend-icon="mdi-chevron-right"
            link
            slim
          >
          </v-list-item>
        </v-list-group>

        <v-list-group
          v-if="corporation && corporation.medicineQuestionAvailable"
          value="medicineQuestion"
          collapse-icon="none"
        >
          <template v-slot:activator="{ props }">
            <v-list-item
              prepend-icon="custom:pill"
              title="くすりぼ"
              class="no-click"
              slim
            ></v-list-item>
          </template>

          <v-list-item
            :to="{ path: '/medicine_question_analytics'}"
            prepend-icon="mdi-chevron-right"
            link
            title="利用・アンケート集計"
            slim
          >
          </v-list-item>
        </v-list-group>

        <v-list-group
          value="medicalInformations"
          collapse-icon="none"
        >
          <template v-slot:activator="{ props }">
            <v-list-item
              prepend-icon="custom:send"
              title="医療情報配信"
              class="no-click"
              slim
            ></v-list-item>
          </template>

          <v-list-item
            :to="{ path: '/medical_informations'}"
            prepend-icon="mdi-chevron-right"
            link
            title="配信履歴一覧"
            slim
          >
          </v-list-item>
        </v-list-group>

        <v-list-group
          v-if="role.isSales()"
          value="tasks"
          collapse-icon="none"
        >
          <template v-slot:activator="{ props }">
            <v-list-item
              prepend-icon="custom:checkList"
              title="社員タスク"
              class="no-click"
              slim
            ></v-list-item>
          </template>

          <v-list-item
            link
            :to="{ path: '/send_monthly_mail'}"
            prepend-icon="mdi-chevron-right"
            title="メール送信"
            slim
          >
          </v-list-item>
        </v-list-group>

        <v-list-group
          value="externalLinks"
          class="links"
          expand-icon="mdi-plus"
          collapse-icon="mdi-minus"
        >
          <template v-slot:activator="{ props }">
            <v-list-item
              v-bind="props"
              title="利用者ページ"
              slim
            ></v-list-item>
          </template>

          <v-list-item
            href="https://syounika.jp/"
            target="_blank"
            slim
          >
            <v-list-item-title>
              小児科オンライン
              <v-icon class="ml-1" icon="mdi-open-in-new" size="x-small"></v-icon>
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            href="https://obstetrics.jp/"
            target="_blank"
            slim
          >
            <v-list-item-title>
              産婦人科オンライン
              <v-icon class="ml-1" icon="mdi-open-in-new" size="x-small"></v-icon>
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            href="https://journal.syounika.jp/"
            target="_blank"
            slim
          >
            <v-list-item-title>
              小児科オンラインジャーナル
              <v-icon class="ml-1" icon="mdi-open-in-new" size="x-small"></v-icon>
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            href="https://journal.obstetrics.jp/"
            target="_blank"
            slim
          >
            <v-list-item-title>
              産婦人科オンラインジャーナル
              <v-icon class="ml-1" icon="mdi-open-in-new" size="x-small"></v-icon>
            </v-list-item-title>
          </v-list-item>

          <v-list-item
            href="https://kids-public.co.jp/live/"
            target="_blank"
            slim
          >
            <v-list-item-title>
              LIVE配信予定
              <v-icon class="ml-1" icon="mdi-open-in-new" size="x-small"></v-icon>
            </v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group
          value="snsLinks"
          class="links"
          expand-icon="mdi-plus"
          collapse-icon="mdi-minus"
        >
          <template v-slot:activator="{ props }">
            <v-list-item
              v-bind="props"
              title="SNS"
              slim
            ></v-list-item>
          </template>

          <v-list-item
            href="https://x.com/syounikaonline"
            target="_blank"
            slim
          >
            <v-list-item-title>
              小児科オンラインX
              <v-icon class="ml-1" icon="mdi-open-in-new" size="x-small"></v-icon>
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            href="https://x.com/obstetricsjp"
            target="_blank"
            slim
          >
            <v-list-item-title>
              産婦人科オンラインX
              <v-icon class="ml-1" icon="mdi-open-in-new" size="x-small"></v-icon>
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            href="https://lin.ee/rO3INMO"
            target="_blank"
            slim
          >
            <v-list-item-title>
              小児科LINE
              <v-icon class="ml-1" icon="mdi-open-in-new" size="x-small"></v-icon>
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            href="https://lin.ee/pBnJhr5"
            target="_blank"
            slim
          >
            <v-list-item-title>
              産婦人科LINE
              <v-icon class="ml-1" icon="mdi-open-in-new" size="x-small"></v-icon>
            </v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-container>
    <v-footer>
      <copyright />
    </v-footer>
  </v-navigation-drawer>
</template>
<script type="ts">
import { defineComponent, computed} from "vue"
import { roles } from "../../service/roles"
import { useStore } from "../../stores/index"
import { useRoute } from "vue-router"
import copyright from "./Copyright.vue"

export default defineComponent({
  name: "SideNavigationPart",
  components: {
    copyright
  },
  setup() {
    // vuex
    const store = useStore()
    const route = useRoute()
    // data
    const currentUser = computed(() => store.getters.currentUser)
    const corporation = computed(() => store.getters.corporation)
    const role = roles()
    const openedGroups = ['achievements', 'casesearch', 'medicineQuestion', 'medicalInformations', 'tasks']

    return {
      currentUser,
      role,
      corporation,
      route,
      openedGroups
    }
  }
})
</script>
<style lang="scss">
.side-nav {
  .v-list {
    .v-list-item {
      .v-list-item-title {
        font-size: 0.875rem;
        font-weight: bold;
      }
      .v-list-item__prepend {
        color: #3ACAC9;
        font-size: 0.7rem;
        /* アイコンと文字列の間隔を調整 */
        .v-list-item__spacer{
          width: 5px !important;
        }
      }
      .v-list-item__content {
        z-index: 100;
      }
      /* トランジションの基本設定 */
      .v-list-item__overlay {
        transition: opacity 0.2s ease-in-out;
        background-color: #C1EEEB !important;
      }
      /* 非アクティブ状態の設定*/
      &:not(.v-list-item--active) {
        .v-list-item__overlay {
          opacity: 0;
        }
      }
      /* アクティブ時の設定 */
      &.v-list-item--active:not(.list-home):not(.no-click) {
        .v-list-item__overlay {
        /* 透明度で背景色を調整 */
        opacity: 0.5 !important;
        }
      }
      &:hover {
        color: #3ACAC9;
        .v-list-item__overlay {
          opacity: 0 !important;
        }
      }
    }

    .no-click {
      pointer-events: none;
      .v-list-item-title {
        font-weight: normal;
      }
      .v-list-item__overlay {
        opacity: 0 !important;
      }
    }

    /** 小見出し */
    .v-list-group__items {
      --indent-padding: 18px;

      .v-list-item {
        min-height: 45px;
        padding-top:2px;
        padding-bottom:2px;
      }
    }

    /** NOTE: 暫定対応 vuetify側の不具合で、homeメニューに常に active クラスがついてしまう問題があるため個別対応 */
    .list-home.v-list-item--active.home-active {
      .v-list-item__overlay {
        background-color: #C1EEEB !important;
        opacity: 0.5 !important;
      }
    }
    .list-home:not(.home-active) {
      .v-list-item__overlay {
        opacity: 0;
      }
    }

    /** リンクメニュー */
    .v-list-group.links {
      .v-list-group__items {
        --indent-padding: 0px;

        .v-list-item {
          font-size: 0.875rem;
          .v-list-item-title {
            font-weight: normal;
          }
          .v-list-item__append {
            .v-icon{
              opacity: 1;
            }
            .v-icon--size-default {
              font-size: 0.9rem;
            }
          }
        }
      }
      .v-list-item.v-list-item--active {
        .v-list-item__overlay {
          opacity: 0 !important;
        }
      }
    }
  }
}
</style>
